<div class="modal" *ngIf="showModal">
    <!-- Modal content -->
    <div class="modal-content">
        <p class="modal-title">As a Product Owner do you Estimate the product backlog Reliably?</p>
        <div class="details">
            <p>
                Interested to know more about how USeP-jira works? Play around with the demo so you get a feel of the workflow.
            </p>
            <p>
                Enter your details below.
            </p>
            <form [formGroup]="registerForm" (ngSubmit)="closeModal()">
            <input formControlName="firstName" placeholder="Name" class="modalInput">
            <input  placeholder="Email" formControlName="email"  type="email" class="modalInput">
            </form>
        </div>
        <div class="button_class">
            <button class="btn modal-btn-blue" (click)="closeModal()"> Continue</button>
        </div>
    </div>

</div>
<div class="modal" *ngIf="showTaskModal">
    <div class="modal-content-small">
        <p class="modal-title">Add New Task Description</p>
        <input [(ngModel)]="newTask"
               name="text">
        <div class="modal-btns">
            <button class="modal-btn-green" (click)="addNewTaskToTable()">Add Task</button>
            <button class="modal-btn-cancel" (click)="this.showTaskModal = false;">Cancel</button>
        </div>
    </div>
</div>

<div class="modal" *ngIf="exceededCount">
    <div class="modal-content-small">
        <p class="modal-title">Exceeded Tries</p>
        <p>
            Please download the application.
        </p>
        <!--        <div class="modal-btns">-->
        <!--            <button class="modal-btn-cancel" (click)="this.exceededCount  = false;">Cancel</button>-->
        <!--        </div>-->
    </div>
</div>


<block-ui>
    <div class="main-content  ">
        <div class="first_line_divisions">
            <span class="playground"> USEP JIRA Playground</span>
            <div style="justify-self: end">
                <img src="assets/KA_LOGO.jpg" height="70px" style="align-self: center; justify-self: end">
            </div>
        </div>
        <div>
            <div class="first_line">
                <span class="labels">Estimate User Story<span *ngIf="storyPoint">( Story Point:  {{this.storyPoint}} )</span></span>
                <span class="part2 labels" *ngIf="!this.stories">How To Plan Better</span>
            </div>

            <form (ngSubmit)="getStories()">
                <div class="input_text">
                    <div>
                        <input placeholder="As a [Type of User], I want to [do something], [so that]"
                               [(ngModel)]="textField"
                               name="text">
                    </div>
                    <img src="assets/enter.svg" class="symbol" (click)="getStories()" *ngIf="!stories">
                    <img src="assets/close.svg" class="symbol" (click)="close()" *ngIf="stories">
                </div>

            </form>
            <div class="example_text" *ngIf="!this.stories">
                <span>Example : As a Admin User,  I need to manage Newsletter subscribers to create a market funnel </span>
            </div>

            <div *ngIf="this.estimateData !== null">
                <div class="table-container">
                    <table class="task_table" border="0">
                        <thead>
                        <tr>
                            <th>

                            </th>
                            <th>
                                Confirming Task
                            </th>
                            <th>
                                Estimate
                            </th>
                        </tr>
                        </thead>
                        <tbody style="border-top:2px solid grey">
                        <tr *ngFor="let row of estimateData; let i =index">
                            <td>
                                {{i + 1}}
                            </td>
                            <td>
                                {{row?.task_desc}}
                            </td>
                            <td>
                                {{row?.estimate}}
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="button-grp" *ngIf="!estimates">
                    <div class="button_class">
                        <button class="btn blue-btn" (click)="addTask()"> Add Task</button>
                    </div>
                    <div class="button_class justify-right">
                        <button class="btn green-btn" (click)="showEstimate()"> Show Estimate</button>
                    </div>
                </div>
                <div class="button-grp" *ngIf="estimates">
                    <button class="btn blue-btn" (click)="close()">Back</button>
                </div>
            </div>
        </div>
<!--        <div style="justify-self: start">-->
<!--            <img src="assets/amrut.svg" height="70px" style="align-self: center">-->
<!--        </div>-->
    </div>
</block-ui>
